import React, { useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import "../App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Dropdown from "react-bootstrap/Dropdown";
import Cards from "../components/Cards";

const App = () => {
  const [isPercentage, setIsPercentage] = useState(false);
  const [selectedMetric, setSelectedMetric] = useState("record_count");

  const record_count_percentage = {
    chart: {
      type: "column",
      backgroundColor: "#FBFEFF",
      borderRadius: 4,
      fontFamily: "'Roboto Flex', serif",
      height: 400, // Increased height
    },
    credits: { enabled: false },
    title: {
      text: " Record Count by Carrier ",
      style: {
        color: "#333333",
        fontFamily: "'Montserrat', serif",
        fontSize: "20px",
        fontWeight: "bold",
      },
      margin: 10,
    },
    xAxis: {
      categories: ["Aetna", "BCBS", "Cigna", "UHC"],
      lineColor: "#CDCDCD",
      lineWidth: 1,
      labels: {
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#555555",
          fontSize: "12px",
        },
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "Percentage (%)",
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#555555",
          fontWeight: "400",
        },
        margin: 5,
      },
      gridLineColor: "#EDEDED", // Light color (was too faint)
      lineColor: "#CDCDCD", // Ensure a visible axis line
      lineWidth: 1, // Add a border line to y-axis
      labels: {
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#555555",
          fontSize: "12px",
        },
      },
    },

    tooltip: {
      headerFormat:
        '<span style="font-size: 14px; color: #5A5A5A;">{point.key}</span><br>' +
        '<span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>',
      shared: true,
      backgroundColor: "rgba(255, 255, 255, 1)",
      borderColor: "#A9A9A9",
      borderRadius: 7,
      animation: false, // Disables animation for instant display
      hideDelay: 0, // Removes delay when hiding the tooltip
      style: {
        color: "#333",
        fontFamily: "'Roboto Flex', serif",
        fontSize: "12px",
        padding: "8px",
        transition: "none", // Ensures no transition delay
        lineHeight: "20px", // Increased line spacing
        boxShadow: "1px 1px 1px rgba(172, 171, 171, 0.1)",
      },
      formatter: function () {
        let tooltipContent = `<span style="font-size: 14px; color: #5A5A5A;">${this.x}</span><br>
                          <span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>`;

        this.points.forEach((point) => {
          tooltipContent += `<span>${point.series.name}:</span> 
                         <b>${point.y.toLocaleString()}</b> 
                         (${point.percentage.toFixed(2)}%)<br/>`;
        });

        return tooltipContent;
      },
    },

    plotOptions: {
      series: {
        opacity: 1,
        states: {
          hover: {
            enabled: false,
          },

          inactive: {
            opacity: 1,
          },

          halo: {
            opacity: 1,
          },
          select: {
            enabled: false,
            halo: {
              opacity: 1,
            },
          },
        },
      },

      column: {
        stacking: "percent", // Percentage stacking
        borderWidth: 0.3,
        dataLabels: {
          enabled: true,
          format: "{point.percentage:.0f}%",
          style: {
            fontFamily: "'Roboto Flex', serif",
            fontSize: "0px",
            fontWeight: "400",
            color: "white",
          },
        },
        borderRadius: 8,
        depth: 45, // Reduced 3D depth for subtlety
      },
    },
    legend: {
      symbolHeight: 12,
      symbolWidth: 12,
      symbolRadius: 4,
      itemStyle: {
        color: "#333",
        fontSize: "13px",
        fontWeight: "500",
        fontFamily: "'Roboto Flex', serif",
      },
      padding: 5,
    },
    series: [
      {
        name: "Negotiated",
        data: [37.05, 36.78, 15.1, 99.73],
        color: "#c4dbd9",
      },
      { name: "Per Diem", data: [0.19, 0.85, 0.01, 0.13], color: "#f7bf9e" },
      {
        name: "Fee Schedule",
        data: [58.74, 58.77, 84.07, null],
        color: "#f7e6da",
      },
      {
        name: "Percentage",
        data: [4.01, 2.5, 0.8, 0.15],
        color: "#f4e7bb",
      },
      { name: "Derived", data: [null, 0.69, 0.01, null], color: "#c2e2ea" },
      { name: "Bundle", data: [null, 0.4, null, null], color: "#d7e3fc " },
    ],
    exporting: { enabled: false },
  };

  const tin_count_percentage = {
    chart: {
      type: "column",
      backgroundColor: "#FBFEFF",
      borderRadius: 4,
      fontFamily: "'Roboto Flex', serif",
      height: 400, // Increased height
    },
    credits: { enabled: false },
    title: {
      text: "TIN Count by Carrier",
      style: {
        color: "#333333",
        fontFamily: "'Montserrat', serif",
        fontSize: "20px",
        fontWeight: "bold",
      },
      margin: 10,
    },
    xAxis: {
      categories: ["Aetna", "BCBS", "Cigna", "UHC"],
      lineColor: "#CDCDCD",
      lineWidth: 1,
      labels: {
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#555555",
          fontSize: "12px",
        },
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "Percentage (%)",
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#555555",
          fontWeight: "400",
        },
        margin: 5,
      },
      gridLineColor: "#EDEDED", // Light color (was too faint)
      lineColor: "#CDCDCD", // Ensure a visible axis line
      lineWidth: 1, // Add a border line to y-axis
      labels: {
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#555555",
          fontSize: "12px",
        },
      },
    },

    tooltip: {
      headerFormat:
        '<span style="font-size: 14px; color: #5A5A5A;">{point.key}</span><br>' +
        '<span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>',
      shared: true,
      backgroundColor: "rgba(255, 255, 255, 1)",
      borderColor: "#A9A9A9",
      borderRadius: 7,
      animation: false, // Disables animation for instant display
      hideDelay: 0, // Removes delay when hiding the tooltip
      style: {
        color: "#333",
        fontFamily: "'Roboto Flex', serif",
        fontSize: "12px",
        padding: "8px",
        transition: "none", // Ensures no transition delay
        lineHeight: "20px", // Increased line spacing
        boxShadow: "1px 1px 1px rgba(172, 171, 171, 0.1)",
      },
      formatter: function () {
        let tooltipContent = `<span style="font-size: 14px; color: #5A5A5A;">${this.x}</span><br>
                          <span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>`;

        this.points.forEach((point) => {
          tooltipContent += `<span>${point.series.name}:</span> 
                         <b>${point.y.toLocaleString()}</b> 
                         (${point.percentage.toFixed(2)}%)<br/>`;
        });

        return tooltipContent;
      },
    },

    plotOptions: {
      series: {
        opacity: 1,
        states: {
          hover: {
            enabled: false,
          },

          inactive: {
            opacity: 1,
          },

          halo: {
            opacity: 1,
          },
          select: {
            enabled: false,
            halo: {
              opacity: 1,
            },
          },
        },
      },

      column: {
        stacking: "percent", // Percentage stacking
        borderWidth: 0.3,
        dataLabels: {
          enabled: true,
          format: "{point.percentage:.0f}%",
          style: {
            fontFamily: "'Roboto Flex', serif",
            fontSize: "0px",
            fontWeight: "400",
            color: "white",
          },
        },
        borderRadius: 8,
        depth: 45, // Reduced 3D depth for subtlety
      },
    },
    legend: {
      symbolHeight: 12,
      symbolWidth: 12,
      symbolRadius: 4,
      itemStyle: {
        color: "#333",
        fontSize: "13px",
        fontWeight: "500",
        fontFamily: "'Roboto Flex', serif",
      },
      padding: 5,
    },
    series: [
      {
        name: "Negotiated",
        data: [26.86, 42.68, 5.05, 97.14],
        color: "#c4dbd9",
      },
      { name: "Per Diem", data: [4.21, 6.24, 0.26, 5.08], color: "#f7bf9e" },
      {
        name: "Fee Schedule",
        data: [74.74, 62.39, 97.24, null],
        color: "#f7e6da",
      },
      {
        name: "Percentage",
        data: [3.37, 11.22, 12.55, 1.05],
        color: "#f4e7bb",
      },
      { name: "Derived", data: [null, 2.608, 0.0, null], color: "#c2e2ea" },
      { name: "Bundle", data: [null, 1.23, null, null], color: "#d7e3fc " },
    ],
    exporting: { enabled: false },
  };

  const provider_count_percentage = {
    chart: {
      type: "column",
      backgroundColor: "#FBFEFF",
      borderRadius: 4,
      fontFamily: "'Roboto Flex', serif",
      height: 400, // Increased height
    },
    credits: { enabled: false },
    title: {
      text: " Provider Count by Carrier",
      style: {
        color: "#333333",
        fontFamily: "'Montserrat', serif",
        fontSize: "20px",
        fontWeight: "bold",
      },
      margin: 10,
    },
    xAxis: {
      categories: ["Aetna", "BCBS", "Cigna", "UHC"],
      lineColor: "#CDCDCD",
      lineWidth: 1,
      labels: {
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#555555",
          fontSize: "12px",
        },
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "Percentage (%)",
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#555555",
          fontWeight: "400",
        },
        margin: 5,
      },
      gridLineColor: "#EDEDED", // Light color (was too faint)
      lineColor: "#CDCDCD", // Ensure a visible axis line
      lineWidth: 1, // Add a border line to y-axis
      labels: {
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#555555",
          fontSize: "12px",
        },
      },
    },

    tooltip: {
      headerFormat:
        '<span style="font-size: 14px; color: #5A5A5A;">{point.key}</span><br>' +
        '<span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>',
      shared: true,
      backgroundColor: "rgba(255, 255, 255, 1)",
      borderColor: "#A9A9A9",
      borderRadius: 7,
      animation: false, // Disables animation for instant display
      hideDelay: 0, // Removes delay when hiding the tooltip
      style: {
        color: "#333",
        fontFamily: "'Roboto Flex', serif",
        fontSize: "12px",
        padding: "8px",
        transition: "none", // Ensures no transition delay
        lineHeight: "20px", // Increased line spacing
        boxShadow: "1px 1px 1px rgba(172, 171, 171, 0.1)",
      },
      formatter: function () {
        let tooltipContent = `<span style="font-size: 14px; color: #5A5A5A;">${this.x}</span><br>
                          <span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>`;

        this.points.forEach((point) => {
          tooltipContent += `<span>${point.series.name}:</span> 
                         <b>${point.y.toLocaleString()}</b> 
                         (${point.percentage.toFixed(2)}%)<br/>`;
        });

        return tooltipContent;
      },
    },

    plotOptions: {
      series: {
        opacity: 1,
        states: {
          hover: {
            enabled: false,
          },

          inactive: {
            opacity: 1,
          },

          halo: {
            opacity: 1,
          },
          select: {
            enabled: false,
            halo: {
              opacity: 1,
            },
          },
        },
      },

      column: {
        stacking: "percent", // Percentage stacking
        borderWidth: 0.3,
        dataLabels: {
          enabled: true,
          format: "{point.percentage:.0f}%",
          style: {
            fontFamily: "'Roboto Flex', serif",
            fontSize: "0px",
            fontWeight: "400",
            color: "white",
          },
        },
        borderRadius: 8,
        depth: 45, // Reduced 3D depth for subtlety
      },
    },
    legend: {
      symbolHeight: 12,
      symbolWidth: 12,
      symbolRadius: 4,
      itemStyle: {
        color: "#333",
        fontSize: "13px",
        fontWeight: "500",
        fontFamily: "'Roboto Flex', serif",
      },
      padding: 5,
    },
    series: [
      {
        name: "Negotiated",
        data: [41.89, 44.58, 6.65, 98.57],
        color: "#c4dbd9",
      },
      { name: "Per Diem", data: [2.06, 3.91, 0.25, 2.4], color: "#f7bf9e" },
      {
        name: "Fee Schedule",
        data: [61.42, 65.0, 96.51, null],
        color: "#f7e6da",
      },
      {
        name: "Percentage",
        data: [3.37, 11.84, 14.12, 1.05],
        color: "#f4e7bb",
      },
      { name: "Derived", data: [null, 2.72, 0.001, null], color: "#c2e2ea" },
      { name: "Bundle", data: [null, 0.6, null, null], color: "#d7e3fc " },
    ],
    exporting: { enabled: false },
  };

  const code_count_percentage = {
    chart: {
      type: "column",
      backgroundColor: "#FBFEFF",
      borderRadius: 4,
      fontFamily: "'Roboto Flex', serif",
      height: 400, // Increased height
    },
    credits: { enabled: false },
    title: {
      text: "Billing Code Count by Carrier",
      style: {
        color: "#333333",
        fontFamily: "'Montserrat', serif",
        fontSize: "20px",
        fontWeight: "bold",
      },
      margin: 10,
    },
    xAxis: {
      categories: ["Aetna", "BCBS", "Cigna", "UHC"],
      lineColor: "#CDCDCD",
      lineWidth: 1,
      labels: {
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#555555",
          fontSize: "12px",
        },
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "Percentage (%)",
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#555555",
          fontWeight: "400",
        },
        margin: 5,
      },
      gridLineColor: "#EDEDED", // Light color (was too faint)
      lineColor: "#CDCDCD", // Ensure a visible axis line
      lineWidth: 1, // Add a border line to y-axis
      labels: {
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#555555",
          fontSize: "12px",
        },
      },
    },

    tooltip: {
      headerFormat:
        '<span style="font-size: 14px; color: #5A5A5A;">{point.key}</span><br>' +
        '<span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>',
      shared: true,
      backgroundColor: "rgba(255, 255, 255, 1)",
      borderColor: "#A9A9A9",
      borderRadius: 7,
      animation: false, // Disables animation for instant display
      hideDelay: 0, // Removes delay when hiding the tooltip
      style: {
        color: "#333",
        fontFamily: "'Roboto Flex', serif",
        fontSize: "12px",
        padding: "8px",
        transition: "none", // Ensures no transition delay
        lineHeight: "20px", // Increased line spacing
        boxShadow: "1px 1px 1px rgba(172, 171, 171, 0.1)",
      },
      formatter: function () {
        let tooltipContent = `<span style="font-size: 14px; color: #5A5A5A;">${this.x}</span><br>
                          <span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>`;

        this.points.forEach((point) => {
          tooltipContent += `<span>${point.series.name}:</span> 
                         <b>${point.y.toLocaleString()}</b> 
                         (${point.percentage.toFixed(2)}%)<br/>`;
        });

        return tooltipContent;
      },
    },

    plotOptions: {
      series: {
        opacity: 1,
        states: {
          hover: {
            enabled: false,
          },

          inactive: {
            opacity: 1,
          },

          halo: {
            opacity: 1,
          },
          select: {
            enabled: false,
            halo: {
              opacity: 1,
            },
          },
        },
      },

      column: {
        stacking: "percent", // Percentage stacking
        borderWidth: 0.3,
        dataLabels: {
          enabled: true,
          format: "{point.percentage:.0f}%",
          style: {
            fontFamily: "'Roboto Flex', serif",
            fontSize: "0px",
            fontWeight: "400",
            color: "white",
          },
        },
        borderRadius: 8,
        depth: 45, // Reduced 3D depth for subtlety
      },
    },
    legend: {
      symbolHeight: 12,
      symbolWidth: 12,
      symbolRadius: 4,
      itemStyle: {
        color: "#333",
        fontSize: "13px",
        fontWeight: "500",
        fontFamily: "'Roboto Flex', serif",
      },
      padding: 5,
    },
    series: [
      {
        name: "Negotiated",
        data: [86.89, 73.54, 79.88, 98.89],
        color: "#c4dbd9",
      },
      { name: "Per Diem", data: [5.91, 52.58, 3.23, 2.4], color: "#f7bf9e" },
      {
        name: "Fee Schedule",
        data: [91.34, 76.38, 79.88, null],
        color: "#f7e6da",
      },
      {
        name: "Percentage",
        data: [73.43, 73.43, 59.26, 32.22],
        color: "#f4e7bb",
      },
      { name: "Derived", data: [null, 43.58, 11.16, null], color: "#c2e2ea" },
      { name: "Bundle", data: [null, 36.75, null, null], color: "#d7e3fc " },
    ],
    exporting: { enabled: false },
  };

  // Count chart options (using "normal" stacking)
  const record_count_count = {
    chart: {
      type: "column",
      backgroundColor: "#FBFEFF",
      borderRadius: 4,
      fontFamily: "'Roboto Flex', serif",
      height: 400, // Increased height
    },
    credits: { enabled: false },
    title: {
      text: "Record Count by Carrier",
      style: {
        color: "#333333",
        fontFamily: "'Montserrat', serif",
        fontSize: "20px",
        fontWeight: "bold",
      },
      margin: 10,
    },
    xAxis: {
      categories: ["Aetna", "BCBS", "Cigna", "UHC"],
      lineColor: "#CDCDCD",
      lineWidth: 1,
      labels: {
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#555555",
          fontSize: "12px",
        },
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "Count",
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#555555",
          fontWeight: "400",
        },
        margin: 5,
      },
      gridLineColor: "#EDEDED", // Light color (was too faint)
      lineColor: "#CDCDCD", // Ensure a visible axis line
      lineWidth: 1, // Add a border line to y-axis
      labels: {
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#555555",
          fontSize: "12px",
        },
      },
    },
    tooltip: {
      headerFormat:
        '<span style="font-size: 14px; color: #5A5A5A;">{point.key}</span><br>' +
        '<span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>',
      shared: true,
      backgroundColor: "rgba(255, 255, 255, 1)",
      borderColor: "#A9A9A9",
      borderRadius: 7,
      animation: false, // Disables animation for instant display
      hideDelay: 0, // Removes delay when hiding the tooltip
      style: {
        color: "#333",
        fontFamily: "'Roboto Flex', serif",
        fontSize: "12px",
        padding: "8px",
        transition: "none", // Ensures no transition delay
        lineHeight: "20px", // Increased line spacing
        boxShadow: "1px 1px 1px rgba(172, 171, 171, 0.1)",
      },
      formatter: function () {
        let tooltipContent = `<span style="font-size: 14px; color: #5A5A5A;">${this.x}</span><br>
                          <span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>`;

        this.points.forEach((point) => {
          tooltipContent += `<span>${point.series.name}:</span> 
                         <b>${point.y.toLocaleString()}</b> 
                         (${point.percentage.toFixed(2)}%)<br/>`;
        });

        return tooltipContent;
      },
    },

    plotOptions: {
      series: {
        opacity: 1,
        states: {
          hover: {
            enabled: false,
          },

          inactive: {
            opacity: 1,
          },

          halo: {
            opacity: 1,
          },
          select: {
            enabled: false,
            halo: {
              opacity: 1,
            },
          },
        },
      },

      column: {
        stacking: "normal", // Regular stacking
        borderWidth: 0.3,
        dataLabels: {
          enabled: true,
          format: "{point.y}",
          style: {
            fontFamily: "'Roboto Flex', serif",
            fontSize: "0px",
            fontWeight: "400",
            color: "white",
          },
        },
        borderRadius: 8,
        depth: 45, // Reduced 3D depth for subtlety
      },
    },
    legend: {
      symbolHeight: 12,
      symbolWidth: 12,
      symbolRadius: 4,
      itemStyle: {
        color: "#333",
        fontSize: "13px",
        fontWeight: "500",
        fontFamily: "'Roboto Flex', serif",
      },
      padding: 5,
    },
    series: [
      {
        name: "Negotiated",
        data: [13407701, 93611449, 8671105, 177673067],
        color: "#c4dbd9",
      },
      {
        name: "Per Diem",
        data: [70091, 2163501, 6774, 223509],
        color: "#f7bf9e",
      },
      {
        name: "Fee Schedule",
        data: [21259625, 149576633, 48265279, null],
        color: "#f7e6da",
      },
      {
        name: "Percentage",
        data: [1452401, 6353300, 460963, 265858],
        color: "#f4e7bb",
      },
      { name: "Derived", data: [null, 1768800, 3326, null], color: "#c2e2ea" },
      { name: "Bundle", data: [null, 1018843, null, null], color: "#d7e3fc " },
    ],
    exporting: { enabled: false },
  };
  const tin_count_Count = {
    chart: {
      type: "column",
      backgroundColor: "#FBFEFF",
      borderRadius: 4,
      fontFamily: "'Roboto Flex', serif",
      height: 400, // Increased height
    },
    credits: { enabled: false },
    title: {
      text: "TIN Count by Carrier",
      style: {
        color: "#333333",
        fontFamily: "'Montserrat', serif",
        fontSize: "20px",
        fontWeight: "bold",
      },
      margin: 10,
    },
    xAxis: {
      categories: ["Aetna", "BCBS", "Cigna", "UHC"],
      lineColor: "#CDCDCD",
      lineWidth: 1,
      labels: {
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#555555",
          fontSize: "12px",
        },
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "Count",
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#555555",
          fontWeight: "400",
        },
        margin: 5,
      },
      gridLineColor: "#EDEDED", // Light color (was too faint)
      lineColor: "#CDCDCD", // Ensure a visible axis line
      lineWidth: 1, // Add a border line to y-axis
      labels: {
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#555555",
          fontSize: "12px",
        },
      },
    },

    tooltip: {
      headerFormat:
        '<span style="font-size: 14px; color: #5A5A5A;">{point.key}</span><br>' +
        '<span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>',
      shared: true,
      backgroundColor: "rgba(255, 255, 255, 1)",
      borderColor: "#A9A9A9",
      borderRadius: 7,
      animation: false, // Disables animation for instant display
      hideDelay: 0, // Removes delay when hiding the tooltip
      style: {
        color: "#333",
        fontFamily: "'Roboto Flex', serif",
        fontSize: "12px",
        padding: "8px",
        transition: "none", // Ensures no transition delay
        lineHeight: "20px", // Increased line spacing
        boxShadow: "1px 1px 1px rgba(172, 171, 171, 0.1)",
      },
      formatter: function () {
        let tooltipContent = `<span style="font-size: 14px; color: #5A5A5A;">${this.x}</span><br>
                          <span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>`;

        this.points.forEach((point) => {
          tooltipContent += `<span>${point.series.name}:</span> 
                         <b>${point.y.toLocaleString()}</b> 
                         (${point.percentage.toFixed(2)}%)<br/>`;
        });

        return tooltipContent;
      },
    },

    plotOptions: {
      series: {
        opacity: 1,
        states: {
          hover: {
            enabled: false,
          },

          inactive: {
            opacity: 1,
          },

          halo: {
            opacity: 1,
          },
          select: {
            enabled: false,
            halo: {
              opacity: 1,
            },
          },
        },
      },

      column: {
        stacking: "normal", // Regular stacking
        borderWidth: 0.3,
        dataLabels: {
          enabled: true,
          format: "{point.y}",
          style: {
            fontFamily: "'Roboto Flex', serif",
            fontSize: "0px",
            fontWeight: "400",
            color: "white",
          },
        },
        borderRadius: 8,
        depth: 45, // Reduced 3D depth for subtlety
      },
    },
    legend: {
      symbolHeight: 12,
      symbolWidth: 12,
      symbolRadius: 4,
      itemStyle: {
        color: "#333",
        fontSize: "13px",
        fontWeight: "500",
        fontFamily: "'Roboto Flex', serif",
      },
      padding: 5,
    },
    series: [
      {
        name: "Negotiated",
        data: [51018, 145493, 9336, 197539],
        color: "#c4dbd9",
      },
      { name: "Per Diem", data: [8005, 21286, 484, 10324], color: "#f7bf9e" },
      {
        name: "Fee Schedule",
        data: [141969, 212663, 179850, null],
        color: "#f7e6da",
      },
      {
        name: "Percentage",
        data: [6393, 38233, 23209, 2127],
        color: "#f4e7bb",
      },
      { name: "Derived", data: [null, 8890, 6, null], color: "#c2e2ea" },
      { name: "Bundle", data: [null, 4178, null, null], color: "#d7e3fc " },
    ],
    exporting: { enabled: false },
  };
  const provider_count_Count = {
    chart: {
      type: "column",
      backgroundColor: "#FBFEFF",
      borderRadius: 4,
      fontFamily: "'Roboto Flex', serif",
      height: 400, // Increased height
    },
    credits: { enabled: false },
    title: {
      text: "Provider Count by Carrier",
      style: {
        color: "#333333",
        fontFamily: "'Montserrat', serif",
        fontSize: "20px",
        fontWeight: "bold",
      },
      margin: 10,
    },
    xAxis: {
      categories: ["Aetna", "BCBS", "Cigna", "UHC"],
      lineColor: "#CDCDCD",
      lineWidth: 1,
      labels: {
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#555555",
          fontSize: "12px",
        },
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "Count",
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#555555",
          fontWeight: "400",
        },
        margin: 5,
      },
      gridLineColor: "#EDEDED", // Light color (was too faint)
      lineColor: "#CDCDCD", // Ensure a visible axis line
      lineWidth: 1, // Add a border line to y-axis
      labels: {
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#555555",
          fontSize: "12px",
        },
      },
    },
    tooltip: {
      headerFormat:
        '<span style="font-size: 14px; color: #5A5A5A;">{point.key}</span><br>' +
        '<span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>',
      shared: true,
      backgroundColor: "rgba(255, 255, 255, 1)",
      borderColor: "#A9A9A9",
      borderRadius: 7,
      animation: false, // Disables animation for instant display
      hideDelay: 0, // Removes delay when hiding the tooltip
      style: {
        color: "#333",
        fontFamily: "'Roboto Flex', serif",
        fontSize: "12px",
        padding: "8px",
        transition: "none", // Ensures no transition delay
        lineHeight: "20px", // Increased line spacing
        boxShadow: "1px 1px 1px rgba(172, 171, 171, 0.1)",
      },
      formatter: function () {
        let tooltipContent = `<span style="font-size: 14px; color: #5A5A5A;">${this.x}</span><br>
                          <span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>`;

        this.points.forEach((point) => {
          tooltipContent += `<span>${point.series.name}:</span> 
                         <b>${point.y.toLocaleString()}</b> 
                         (${point.percentage.toFixed(2)}%)<br/>`;
        });

        return tooltipContent;
      },
    },
    plotOptions: {
      series: {
        opacity: 1,
        states: {
          hover: {
            enabled: false,
          },

          inactive: {
            opacity: 1,
          },

          halo: {
            opacity: 1,
          },
          select: {
            enabled: false,
            halo: {
              opacity: 1,
            },
          },
        },
      },

      column: {
        stacking: "normal", // Regular stacking
        borderWidth: 0.3,
        dataLabels: {
          enabled: true,
          format: "{point.y}",
          style: {
            fontFamily: "'Roboto Flex', serif",
            fontSize: "0px",
            fontWeight: "400",
            color: "white",
          },
        },
        borderRadius: 8,
        depth: 45, // Reduced 3D depth for subtlety
      },
    },
    legend: {
      symbolHeight: 12,
      symbolWidth: 12,
      symbolRadius: 4,
      itemStyle: {
        color: "#333",
        fontSize: "13px",
        fontWeight: "500",
        fontFamily: "'Roboto Flex', serif",
      },
      padding: 5,
    },
    series: [
      {
        name: "Negotiated",
        data: [211591, 311111, 32432, 623475],
        color: "#c4dbd9",
      },
      { name: "Per Diem", data: [10399, 27306, 1227, 14886], color: "#f7bf9e" },
      {
        name: "Fee Schedule",
        data: [310235, 453675, 470538, null],
        color: "#f7e6da",
      },
      {
        name: "Percentage",
        data: [25266, 82663, 68821, 4039],
        color: "#f4e7bb",
      },
      { name: "Derived", data: [null, 18966, 7, null], color: "#c2e2ea" },
      { name: "Bundle", data: [null, 4171, null, null], color: "#d7e3fc " },
    ],
    exporting: { enabled: false },
  };

  const code_count_Count = {
    chart: {
      type: "column",
      backgroundColor: "#FBFEFF",
      borderRadius: 4,
      fontFamily: "'Roboto Flex', serif",
      height: 400, // Increased height
    },
    credits: { enabled: false },
    title: {
      text: "Billing Code Count by Carrier",
      style: {
        color: "#333333",
        fontFamily: "'Montserrat', serif",
        fontSize: "20px",
        fontWeight: "bold",
      },
      margin: 10,
    },
    xAxis: {
      categories: ["Aetna", "BCBS", "Cigna", "UHC"],
      lineColor: "#CDCDCD",
      lineWidth: 1,
      labels: {
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#555555",
          fontSize: "12px",
        },
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "Count",
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#555555",
          fontWeight: "400",
        },
        margin: 5,
      },
      gridLineColor: "#EDEDED", // Light color (was too faint)
      lineColor: "#CDCDCD", // Ensure a visible axis line
      lineWidth: 1, // Add a border line to y-axis
      labels: {
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#555555",
          fontSize: "12px",
        },
      },
    },

    tooltip: {
      headerFormat:
        '<span style="font-size: 14px; color: #5A5A5A;">{point.key}</span><br>' +
        '<span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>',
      shared: true,
      backgroundColor: "rgba(255, 255, 255, 1)",
      borderColor: "#A9A9A9",
      borderRadius: 7,
      animation: false, // Disables animation for instant display
      hideDelay: 0, // Removes delay when hiding the tooltip
      style: {
        color: "#333",
        fontFamily: "'Roboto Flex', serif",
        fontSize: "12px",
        padding: "8px",
        transition: "none", // Ensures no transition delay
        lineHeight: "20px", // Increased line spacing
        boxShadow: "1px 1px 1px rgba(172, 171, 171, 0.1)",
      },
      formatter: function () {
        let tooltipContent = `<span style="font-size: 14px; color: #5A5A5A;">${this.x}</span><br>
                          <span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>`;

        this.points.forEach((point) => {
          tooltipContent += `<span>${point.series.name}:</span> 
                         <b>${point.y.toLocaleString()}</b> 
                         (${point.percentage.toFixed(2)}%)<br/>`;
        });

        return tooltipContent;
      },
    },
    plotOptions: {
      series: {
        opacity: 1,
        states: {
          hover: {
            enabled: false,
          },

          inactive: {
            opacity: 1,
          },

          halo: {
            opacity: 1,
          },
          select: {
            enabled: false,
            halo: {
              opacity: 1,
            },
          },
        },
      },

      column: {
        stacking: "normal", // Regular stacking
        borderWidth: 0.3,
        dataLabels: {
          enabled: true,
          format: "{point.y}",
          style: {
            fontFamily: "'Roboto Flex', serif",
            fontSize: "0px",
            fontWeight: "400",
            color: "white",
          },
        },
        borderRadius: 8,
        depth: 45, // Reduced 3D depth for subtlety
      },
    },
    legend: {
      symbolHeight: 12,
      symbolWidth: 12,
      symbolRadius: 4,
      itemStyle: {
        color: "#333",
        fontSize: "13px",
        fontWeight: "500",
        fontFamily: "'Roboto Flex', serif",
      },
      padding: 5,
    },
    series: [
      {
        name: "Negotiated",
        data: [14483, 15851, 11909, 12706],
        color: "#c4dbd9",
      },
      { name: "Per Diem", data: [985, 11333, 481, 308], color: "#f7bf9e" },
      {
        name: "Fee Schedule",
        data: [15225, 16462, 13843, null],
        color: "#f7e6da",
      },
      {
        name: "Percentage",
        data: [12240, 18315, 8835, 4140],
        color: "#f4e7bb",
      },
      { name: "Derived", data: [null, 9392, 1664, null], color: "#c2e2ea" },
      { name: "Bundle", data: [null, 7921, null, null], color: "#d7e3fc " },
    ],
    exporting: { enabled: false },
  };

  // Percentage chart options in 3d
  const record_count_percentage_3d = {
    chart: {
      type: "column",
      backgroundColor: "#FBFEFF",
      borderRadius: 4,
      fontFamily: "'Roboto Flex', serif",
      height: 400,
      options3d: {
        enabled: true,
        alpha: 0, // Straight-on view
        beta: 0, // No horizontal rotation
        depth: 100, // Maintain depth for a clear 3D effect
        viewDistance: 30,
        frame: {
          bottom: { size: 1, color: "#fff" },
          back: { size: 1, color: "#FFFFFF" },
          side: { size: 1, color: "#ffffff" },
        },
      },
    },
    credits: { enabled: false },
    title: {
      text: "Record Count by Carrier",
      style: {
        color: "#333333",
        fontFamily: "'Montserrat', serif",
        fontSize: "20px",
        fontWeight: "bold",
      },
      margin: 10,
    },
    xAxis: {
      categories: ["Aetna", "BCBS", "Cigna", "UHC"],
      lineColor: "#000", // Lightened axis line color
      gridLineColor: "transparent",
      lineWidth: 0,
      labels: {
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#777777",
          fontSize: "12px",
        },
      },
    },

    yAxis: {
      min: 0,
      title: {
        text: "Percentage (%)",
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#555555",
          fontWeight: "400",
        },
        margin: 5,
      },
      gridLineColor: "#F6F6F6", // Light color (was too faint)
      lineColor: "#888888", // Ensure a visible axis line
      lineWidth: 1, // Add a border line to y-axis
      labels: {
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#555555",
          fontSize: "12px",
        },
      },
    },
    tooltip: {
      headerFormat:
        '<span style="font-size: 14px; color: #5A5A5A;">{point.key}</span><br>' +
        '<span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>',
      shared: true,
      backgroundColor: "rgba(255, 255, 255, 1)",
      borderColor: "#A9A9A9",
      borderRadius: 7,
      animation: false, // Disables animation for instant display
      hideDelay: 0, // Removes delay when hiding the tooltip
      style: {
        color: "#333",
        fontFamily: "'Roboto Flex', serif",
        fontSize: "12px",
        padding: "8px",
        transition: "none", // Ensures no transition delay
        lineHeight: "20px", // Increased line spacing
        boxShadow: "1px 1px 1px rgba(172, 171, 171, 0.1)",
      },
      formatter: function () {
        let tooltipContent = `<span style="font-size: 14px; color: #5A5A5A;">${this.x}</span><br>
                          <span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>`;

        this.points.forEach((point) => {
          tooltipContent += `<span>${point.series.name}:</span> 
                         <b>${point.y.toLocaleString()}</b> 
                         (${point.percentage.toFixed(2)}%)<br/>`;
        });

        return tooltipContent;
      },
    },

    plotOptions: {
      series: {
        opacity: 1,
        // enableMouseTracking: false,
        states: {
          hover: {
            enabled: false,
          },

          inactive: {
            opacity: 1,
          },

          halo: {
            opacity: 1,
          },
          select: {
            enabled: false,
            halo: {
              opacity: 1,
            },
          },
        },
      },

      column: {
        stacking: "percent",
        borderWidth: 0.3,
        dataLabels: {
          enabled: true,
          format: "{point.percentage:.0f}%",
          style: {
            fontFamily: "'Roboto Flex', serif",
            fontSize: "0px",
            fontWeight: "400",
            color: "white",
          },
        },
        borderRadius: 90,
        depth: 45, // Reduced 3D depth for subtlety
      },
    },
    legend: {
      symbolHeight: 12,
      symbolWidth: 12,

      symbolRadius: 4,
      itemStyle: {
        color: "#333",
        fontSize: "13px",
        fontWeight: "500",
        fontFamily: "'Roboto Flex', serif",
      },
      padding: 5,
    },
    series: [
      {
        name: "Negotiated",
        data: [37.05, 36.78, 15.1, 99.73],
        color: "#c4dbd9",
      },
      { name: "Per Diem", data: [0.19, 0.85, 0.01, 0.13], color: "#f7bf9e" },
      {
        name: "Fee Schedule",
        data: [58.74, 58.77, 84.07, null],
        color: "#f7e6da",
      },
      {
        name: "Percentage",
        data: [4.01, 2.5, 0.8, 0.15],
        color: "#f4e7bb",
      },
      { name: "Derived", data: [null, 0.69, 0.01, null], color: "#c2e2ea" },
      { name: "Bundle", data: [null, 0.4, null, null], color: "#d7e3fc " },
    ],
    exporting: { enabled: false },
  };

  const tin_count_percentage_3d = {
    chart: {
      type: "column",
      backgroundColor: "#FBFEFF",
      borderRadius: 4,
      fontFamily: "'Roboto Flex', serif",
      height: 400,
      options3d: {
        enabled: true,
        alpha: 0, // Straight-on view
        beta: 0, // No horizontal rotation
        depth: 100, // Maintain depth for a clear 3D effect
        viewDistance: 30,
        frame: {
          bottom: { size: 1, color: "#fff" },
          back: { size: 1, color: "#FFFFFF" },
          side: { size: 1, color: "#ffffff" },
        },
      },
    },
    credits: { enabled: false },
    title: {
      text: "TIN Count by Carrier",
      style: {
        color: "#333333",
        fontFamily: "'Montserrat', serif",
        fontSize: "20px",
        fontWeight: "bold",
      },
      margin: 10,
    },
    xAxis: {
      categories: ["Aetna", "BCBS", "Cigna", "UHC"],
      lineColor: "#000", // Lightened axis line color
      gridLineColor: "transparent",
      lineWidth: 0,
      labels: {
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#777777",
          fontSize: "12px",
        },
      },
    },

    yAxis: {
      min: 0,
      title: {
        text: "Percentage (%)",
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#555555",
          fontWeight: "400",
        },
        margin: 5,
      },
      gridLineColor: "#F6F6F6", // Light color (was too faint)
      lineColor: "#888888", // Ensure a visible axis line
      lineWidth: 1, // Add a border line to y-axis
      labels: {
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#555555",
          fontSize: "12px",
        },
      },
    },
    tooltip: {
      headerFormat:
        '<span style="font-size: 14px; color: #5A5A5A;">{point.key}</span><br>' +
        '<span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>',
      shared: true,
      backgroundColor: "rgba(255, 255, 255, 1)",
      borderColor: "#A9A9A9",
      borderRadius: 7,
      animation: false, // Disables animation for instant display
      hideDelay: 0, // Removes delay when hiding the tooltip
      style: {
        color: "#333",
        fontFamily: "'Roboto Flex', serif",
        fontSize: "12px",
        padding: "8px",
        transition: "none", // Ensures no transition delay
        lineHeight: "20px", // Increased line spacing
        boxShadow: "1px 1px 1px rgba(172, 171, 171, 0.1)",
      },
      formatter: function () {
        let tooltipContent = `<span style="font-size: 14px; color: #5A5A5A;">${this.x}</span><br>
                          <span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>`;

        this.points.forEach((point) => {
          tooltipContent += `<span>${point.series.name}:</span> 
                         <b>${point.y.toLocaleString()}</b> 
                         (${point.percentage.toFixed(2)}%)<br/>`;
        });

        return tooltipContent;
      },
    },

    plotOptions: {
      series: {
        opacity: 1,
        // enableMouseTracking: false,
        states: {
          hover: {
            enabled: false,
          },

          inactive: {
            opacity: 1,
          },

          halo: {
            opacity: 1,
          },
          select: {
            enabled: false,
            halo: {
              opacity: 1,
            },
          },
        },
      },

      column: {
        stacking: "percent",
        borderWidth: 0.3,
        dataLabels: {
          enabled: true,
          format: "{point.percentage:.0f}%",
          style: {
            fontFamily: "'Roboto Flex', serif",
            fontSize: "0px",
            fontWeight: "400",
            color: "white",
          },
        },
        borderRadius: 90,
        depth: 45, // Reduced 3D depth for subtlety
      },
    },
    legend: {
      symbolHeight: 12,
      symbolWidth: 12,

      symbolRadius: 4,
      itemStyle: {
        color: "#333",
        fontSize: "13px",
        fontWeight: "500",
        fontFamily: "'Roboto Flex', serif",
      },
      padding: 5,
    },
    series: [
      {
        name: "Negotiated",
        data: [26.86, 42.68, 5.05, 97.14],
        color: "#c4dbd9",
      },
      { name: "Per Diem", data: [4.21, 6.24, 0.26, 5.08], color: "#f7bf9e" },
      {
        name: "Fee Schedule",
        data: [74.74, 62.39, 97.24, null],
        color: "#f7e6da",
      },
      {
        name: "Percentage",
        data: [3.37, 11.22, 12.55, 1.05],
        color: "#f4e7bb",
      },
      { name: "Derived", data: [null, 2.608, 0.0, null], color: "#c2e2ea" },
      { name: "Bundle", data: [null, 1.23, null, null], color: "#d7e3fc " },
    ],

    exporting: { enabled: false },
  };

  const provider_count_percentage_3d = {
    chart: {
      type: "column",
      backgroundColor: "#FBFEFF",
      borderRadius: 4,
      fontFamily: "'Roboto Flex', serif",
      height: 400,
      options3d: {
        enabled: true,
        alpha: 0, // Straight-on view
        beta: 0, // No horizontal rotation
        depth: 100, // Maintain depth for a clear 3D effect
        viewDistance: 30,
        frame: {
          bottom: { size: 1, color: "#fff" },
          back: { size: 1, color: "#FFFFFF" },
          side: { size: 1, color: "#ffffff" },
        },
      },
    },
    credits: { enabled: false },
    title: {
      text: "Provider Count by Carrier",
      style: {
        color: "#333333",
        fontFamily: "'Montserrat', serif",
        fontSize: "20px",
        fontWeight: "bold",
      },
      margin: 10,
    },
    xAxis: {
      categories: ["Aetna", "BCBS", "Cigna", "UHC"],
      lineColor: "#000", // Lightened axis line color
      gridLineColor: "transparent",
      lineWidth: 0,
      labels: {
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#777777",
          fontSize: "12px",
        },
      },
    },

    yAxis: {
      min: 0,
      title: {
        text: "Percentage (%)",
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#555555",
          fontWeight: "400",
        },
        margin: 5,
      },
      gridLineColor: "#F6F6F6", // Light color (was too faint)
      lineColor: "#888888", // Ensure a visible axis line
      lineWidth: 1, // Add a border line to y-axis
      labels: {
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#555555",
          fontSize: "12px",
        },
      },
    },
    tooltip: {
      headerFormat:
        '<span style="font-size: 14px; color: #5A5A5A;">{point.key}</span><br>' +
        '<span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>',
      shared: true,
      backgroundColor: "rgba(255, 255, 255, 1)",
      borderColor: "#A9A9A9",
      borderRadius: 7,
      animation: false, // Disables animation for instant display
      hideDelay: 0, // Removes delay when hiding the tooltip
      style: {
        color: "#333",
        fontFamily: "'Roboto Flex', serif",
        fontSize: "12px",
        padding: "8px",
        transition: "none", // Ensures no transition delay
        lineHeight: "20px", // Increased line spacing
        boxShadow: "1px 1px 1px rgba(172, 171, 171, 0.1)",
      },
      formatter: function () {
        let tooltipContent = `<span style="font-size: 14px; color: #5A5A5A;">${this.x}</span><br>
                          <span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>`;

        this.points.forEach((point) => {
          tooltipContent += `<span>${point.series.name}:</span> 
                         <b>${point.y.toLocaleString()}</b> 
                         (${point.percentage.toFixed(2)}%)<br/>`;
        });

        return tooltipContent;
      },
    },

    plotOptions: {
      series: {
        opacity: 1,
        // enableMouseTracking: false,
        states: {
          hover: {
            enabled: false,
          },

          inactive: {
            opacity: 1,
          },

          halo: {
            opacity: 1,
          },
          select: {
            enabled: false,
            halo: {
              opacity: 1,
            },
          },
        },
      },

      column: {
        stacking: "percent",
        borderWidth: 0.3,
        dataLabels: {
          enabled: true,
          format: "{point.percentage:.0f}%",
          style: {
            fontFamily: "'Roboto Flex', serif",
            fontSize: "0px",
            fontWeight: "400",
            color: "white",
          },
        },
        borderRadius: 90,
        depth: 45, // Reduced 3D depth for subtlety
      },
    },
    legend: {
      symbolHeight: 12,
      symbolWidth: 12,

      symbolRadius: 4,
      itemStyle: {
        color: "#333",
        fontSize: "13px",
        fontWeight: "500",
        fontFamily: "'Roboto Flex', serif",
      },
      padding: 5,
    },
    series: [
      {
        name: "Negotiated",
        data: [41.89, 44.58, 6.65, 98.57],
        color: "#c4dbd9",
      },
      { name: "Per Diem", data: [2.06, 3.91, 0.25, 2.4], color: "#f7bf9e" },
      {
        name: "Fee Schedule",
        data: [61.42, 65.0, 96.51, null],
        color: "#f7e6da",
      },
      {
        name: "Percentage",
        data: [3.37, 11.84, 14.12, 1.05],
        color: "#f4e7bb",
      },
      { name: "Derived", data: [null, 2.72, 0.001, null], color: "#c2e2ea" },
      { name: "Bundle", data: [null, 0.6, null, null], color: "#d7e3fc " },
    ],

    exporting: { enabled: false },
  };

  const code_count_percentage_3d = {
    chart: {
      type: "column",
      backgroundColor: "#FBFEFF",
      borderRadius: 4,
      fontFamily: "'Roboto Flex', serif",
      height: 400,
      options3d: {
        enabled: true,
        alpha: 0, // Straight-on view
        beta: 0, // No horizontal rotation
        depth: 100, // Maintain depth for a clear 3D effect
        viewDistance: 30,
        frame: {
          bottom: { size: 1, color: "#fff" },
          back: { size: 1, color: "#FFFFFF" },
          side: { size: 1, color: "#ffffff" },
        },
      },
    },
    credits: { enabled: false },
    title: {
      text: "Billing Code Count by Carrier",
      style: {
        color: "#333333",
        fontFamily: "'Montserrat', serif",
        fontSize: "20px",
        fontWeight: "bold",
      },
      margin: 10,
    },
    xAxis: {
      categories: ["Aetna", "BCBS", "Cigna", "UHC"],
      lineColor: "#000", // Lightened axis line color
      gridLineColor: "transparent",
      lineWidth: 0,
      labels: {
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#777777",
          fontSize: "12px",
        },
      },
    },

    yAxis: {
      min: 0,
      title: {
        text: "Percentage (%)",
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#555555",
          fontWeight: "400",
        },
        margin: 5,
      },
      gridLineColor: "#F6F6F6", // Light color (was too faint)
      lineColor: "#888888", // Ensure a visible axis line
      lineWidth: 1, // Add a border line to y-axis
      labels: {
        style: {
          fontFamily: "'Roboto Flex', serif",
          color: "#555555",
          fontSize: "12px",
        },
      },
    },
    tooltip: {
      headerFormat:
        '<span style="font-size: 14px; color: #5A5A5A;">{point.key}</span><br>' +
        '<span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>',
      shared: true,
      backgroundColor: "rgba(255, 255, 255, 1)",
      borderColor: "#A9A9A9",
      borderRadius: 7,
      animation: false, // Disables animation for instant display
      hideDelay: 0, // Removes delay when hiding the tooltip
      style: {
        color: "#333",
        fontFamily: "'Roboto Flex', serif",
        fontSize: "12px",
        padding: "8px",
        transition: "none", // Ensures no transition delay
        lineHeight: "20px", // Increased line spacing
        boxShadow: "1px 1px 1px rgba(172, 171, 171, 0.1)",
      },
      formatter: function () {
        let tooltipContent = `<span style="font-size: 14px; color: #5A5A5A;">${this.x}</span><br>
                          <span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>`;

        this.points.forEach((point) => {
          tooltipContent += `<span>${point.series.name}:</span> 
                         <b>${point.y.toLocaleString()}</b> 
                         (${point.percentage.toFixed(2)}%)<br/>`;
        });

        return tooltipContent;
      },
    },

    plotOptions: {
      series: {
        opacity: 1,
        // enableMouseTracking: false,
        states: {
          hover: {
            enabled: false,
          },

          inactive: {
            opacity: 1,
          },

          halo: {
            opacity: 1,
          },
          select: {
            enabled: false,
            halo: {
              opacity: 1,
            },
          },
        },
      },

      column: {
        stacking: "percent",
        borderWidth: 0.3,
        dataLabels: {
          enabled: true,
          format: "{point.percentage:.0f}%",
          style: {
            fontFamily: "'Roboto Flex', serif",
            fontSize: "0px",
            fontWeight: "400",
            color: "white",
          },
        },
        borderRadius: 90,
        depth: 45, // Reduced 3D depth for subtlety
      },
    },
    legend: {
      symbolHeight: 12,
      symbolWidth: 12,

      symbolRadius: 4,
      itemStyle: {
        color: "#333",
        fontSize: "13px",
        fontWeight: "500",
        fontFamily: "'Roboto Flex', serif",
      },
      padding: 5,
    },
    series: [
      {
        name: "Negotiated",
        data: [86.89, 73.54, 79.88, 98.89],
        color: "#c4dbd9",
      },
      { name: "Per Diem", data: [5.91, 52.58, 3.23, 2.4], color: "#f7bf9e" },
      {
        name: "Fee Schedule",
        data: [91.34, 76.38, 79.88, null],
        color: "#f7e6da",
      },
      {
        name: "Percentage",
        data: [73.43, 73.43, 59.26, 32.22],
        color: "#f4e7bb",
      },
      { name: "Derived", data: [null, 43.58, 11.16, null], color: "#c2e2ea" },
      { name: "Bundle", data: [null, 36.75, null, null], color: "#d7e3fc " },
    ],

    exporting: { enabled: false },
  };

  return (
    <div className="containers" style={{ padding: "0px 20px" }}>
      <Cards />
      <div>
        <div className="metrics-container">
          {/* <select className="metrics-dropdown" onChange={handleMetricChange}>
            <option value="record_count">Record Count</option>
            <option value="tin_count">TIN Count</option>
            <option value="code_count">Code Count</option>
            <option value="provider_count">Provider Count</option>
          </select> */}

          <Dropdown onSelect={(eventKey) => setSelectedMetric(eventKey)}>
            <Dropdown.Toggle
              variant="primary"
              id="dropdown-basic"
              className="custom-dropdown"
            >
              {selectedMetric === "record_count"
                ? "Record Count"
                : selectedMetric === "tin_count"
                ? "TIN Count"
                : selectedMetric === "code_count"
                ? "Billing Code Count"
                : "Provider Count"}
            </Dropdown.Toggle>

            <Dropdown.Menu className="custom-dropdown-menu">
              <Dropdown.Item eventKey="record_count">
                Record count
              </Dropdown.Item>
              <Dropdown.Item eventKey="code_count">
                Billing code count
              </Dropdown.Item>
              <Dropdown.Item eventKey="provider_count">
                Provider Count
              </Dropdown.Item>
              <Dropdown.Item eventKey="tin_count">TIN Count</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <div className="toggle-buttons">
              <button
                className={`toggle-button ${!isPercentage ? "active" : ""}`}
                onClick={() => setIsPercentage(false)}
              >
                Count
              </button>
              <button
                className={`toggle-button ${isPercentage ? "active" : ""}`}
                onClick={() => setIsPercentage(true)}
              >
                Percentage
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Container for record_count */}
      {selectedMetric === "record_count" && (
        <div
          className={`row d-flex flex-column  ${
            isPercentage ? "percentage-view" : ""
          }`}
        >
          {isPercentage ? (
            <div className="container">
              <div className="chart">
                <HighchartsReact
                  highcharts={Highcharts}
                  options={record_count_percentage}
                />
              </div>
              <div className="chart">
                <HighchartsReact
                  highcharts={Highcharts}
                  options={record_count_percentage_3d}
                />
              </div>
            </div>
          ) : (
            <div className="container">
              <div className="chart">
                <HighchartsReact
                  highcharts={Highcharts}
                  options={record_count_count}
                  style={{ width: "49%" }}
                />
              </div>
            </div>
          )}
        </div>
      )}

      {selectedMetric === "tin_count" && (
        <div
          className={`row d-flex flex-column   ${
            isPercentage ? "percentage-view" : ""
          }`}
        >
          {isPercentage ? (
            <div className="container">
              <div className="chart">
                <HighchartsReact
                  highcharts={Highcharts}
                  options={tin_count_percentage}
                />
              </div>
              <div className="chart">
                <HighchartsReact
                  highcharts={Highcharts}
                  options={tin_count_percentage_3d}
                />
              </div>
            </div>
          ) : (
            <div className="container">
              <div className="chart">
                <HighchartsReact
                  highcharts={Highcharts}
                  options={tin_count_Count}
                  style={{ width: "49%" }}
                />
              </div>
            </div>
          )}
        </div>
      )}
      {selectedMetric === "provider_count" && (
        <div
          className={`row d-flex flex-column   ${
            isPercentage ? "percentage-view" : ""
          }`}
        >
          {isPercentage ? (
            <div className="container">
              <div className="chart">
                <HighchartsReact
                  highcharts={Highcharts}
                  options={provider_count_percentage}
                />
              </div>
              <div className="chart">
                <HighchartsReact
                  highcharts={Highcharts}
                  options={provider_count_percentage_3d}
                />
              </div>
            </div>
          ) : (
            <div className="container">
              <div className="chart">
                <HighchartsReact
                  highcharts={Highcharts}
                  options={provider_count_Count}
                  style={{ width: "49%" }}
                />
              </div>
            </div>
          )}
        </div>
      )}
      {selectedMetric === "code_count" && (
        <div
          className={`row d-flex flex-column   ${
            isPercentage ? "percentage-view" : ""
          }`}
        >
          {isPercentage ? (
            <div className="container">
              <div className="chart">
                <HighchartsReact
                  highcharts={Highcharts}
                  options={code_count_percentage}
                />
              </div>
              <div className="chart">
                <HighchartsReact
                  highcharts={Highcharts}
                  options={code_count_percentage_3d}
                />
              </div>
            </div>
          ) : (
            <div className="container">
              <div className="chart">
                <HighchartsReact
                  highcharts={Highcharts}
                  options={code_count_Count}
                  style={{ width: "49%" }}
                />
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default App;
